
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/gainsightpx",
      function () {
        return require("private-next-pages/destinations/gainsightpx.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/gainsightpx"])
      });
    }
  